module.exports = __webpack_public_path__ + "img/27_2002_ab_7.9204551a.jpg";